// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://lhcsxltcajtaeoqqsgrb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxoY3N4bHRjYWp0YWVvcXFzZ3JiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUwNTk3MDUsImV4cCI6MjA2MDYzNTcwNX0.GtcmnME5GOalUEopkm2zxqC1RvxqgSYzF_bSeY_vyA0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Custom fetch wrapper to handle network errors gracefully
const customFetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  return fetch(input, init).catch((err) => {
    // Suppress network errors silently for Lighthouse/bots
    if (typeof window !== 'undefined' && !window.navigator.onLine) {
      return new Response(JSON.stringify({ error: 'offline' }), { status: 503 });
    }
    throw err;
  });
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
  global: {
    fetch: customFetch,
  },
});
